import React from "react"

// Context
import {useUiSkin} from "../../../ui-skin/context/UiSkinContext"

// Components
import RecordPage from "../RecordPage"
import ModernRecordPage from "../modern/ModernRecordPage"

/**
 * Presentational seam between the two record containers and the two skins.
 *
 * `props: any` is deliberate and is the ONLY place in the Modern port where it
 * is correct: `RecordPageContainer` and `RecordPreviewPageContainer` inject
 * different prop sets (the live route additionally carries the WS lifecycle and
 * inactivity HOC props), and this component must pass both through untouched
 * without narrowing either one.
 *
 * Flipping the skin unmounts one tree and mounts the other. That is intended —
 * the Plotly stage needs a fresh mount anyway, and it guarantees no local
 * review state leaks between skins. `ModernRecordPage` flushes any pending
 * conclusion draft in a cleanup effect so the unmount cannot lose text.
 */
export default function RecordPageSwitch(props: any) {
    const {isModern} = useUiSkin();

    return isModern
        ? <ModernRecordPage {...props}/>
        : <RecordPage {...props}/>
}
